<template>
  <v-select
    :model-value="selectedItem"
    :items="flattenedItems"
    @update:model-value="selectedItem = $event"
    item-title="text"
    item-value="value"
    :label="label"
    return-object
  >
    <template v-slot:item="{ item, props }">
      <v-list-item
        v-bind="props"
        :title="item.raw.text"
        :value="item.raw.value"
      ></v-list-item>
    </template>
  </v-select>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { SELECT_PAGOS } from '@/utils/constants'

const props = defineProps({
  modelValue: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:modelValue'])

const label = ref('Elige una opción')

const route = useRoute()
const selectedItem = ref(null)

const flattenedItems = ref([])

onMounted(() => {
  const routeSegment = route.path.split('/').pop().toUpperCase()

  flattenedItems.value = SELECT_PAGOS.filter(
    (item) => item.type === routeSegment
  )
  console.log(
    'flattenedItems.value[0]',
    flattenedItems.value.length,
    flattenedItems.value[0]
  )
  nextTick(() => {
    if (flattenedItems.value.length === 1) {
      label.value = ''
      emit('update:modelValue', flattenedItems.value[0].value)
      // selectedItem.value = flattenedItems.value[0]
    }
  })
})

watch([flattenedItems, () => props.modelValue], ([newItems, newModelValue]) => {
  if (newModelValue) {
    selectedItem.value =
      SELECT_PAGOS.find((item) => item.value === newModelValue) || null
  } else if (newItems.length === 1) {
    selectedItem.value = newItems[0]
  } else {
    selectedItem.value = null
  }
})

watch(selectedItem, (newValue) => {
  emit('update:modelValue', newValue ? newValue.value : null)
})

// if (props.modelValue) {
//   if (flattenedItems.value.length === 1) {
//     selectedItem.value = flattenedItems.value[0]
//   } else {
//     selectedItem.value =
//       SELECT_PAGOS.find((item) => item.value === props.modelValue) || null
//   }
// }
</script>

<style scoped>
.group-header {
  font-weight: bold;
  color: white;
  padding: 8px 16px;
}

.group-header-C {
  background-color: #92d2f0;
  /* Verde para Cancelaciones y Comisiones */
  color: black;
}

.group-header-E {
  background-color: #92d2f0;
  /* Verde para Cancelaciones y Comisiones */
  color: black;
}

.group-header-H {
  background-color: #92d2f0;
  /* Verde para Cancelaciones y Comisiones */
  color: black;
}

.group-header-I {
  background-color: #92d2f0;
  /* Verde para Cancelaciones y Comisiones */
  color: black;
}
</style>
